import { Box, Button, FormControl, FormLabel, Grid, GridItem, InputGroup, InputRightAddon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useRadioGroup, } from "@chakra-ui/react";
import { FormLabelStyle, NumberInput } from "@govisupro/controls";
import React, { useContext, useEffect, useState } from "react";
import { useServices } from "../hooks/useServices";
import { StudioContext } from "../studioContext";
import { AnimationsRadioGroup } from "./AnimationsRadio";
export const AnimationsModal = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { layoutService } = useServices();
    const { animationsModalOpened, setAnimationsModalOpened, layoutItems, selectedLayoutItemId, } = useContext(StudioContext);
    const layoutItem = layoutItems.find((item) => item.id === selectedLayoutItemId);
    const { getRootProps, getRadioProps, value, setValue } = useRadioGroup({
        defaultValue: (_c = (_b = (_a = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.animations) === null || _a === void 0 ? void 0 : _a.apparition) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : "none",
    });
    const [duration, setDuration] = useState((_f = (_e = (_d = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.animations) === null || _d === void 0 ? void 0 : _d.apparition) === null || _e === void 0 ? void 0 : _e.duration) !== null && _f !== void 0 ? _f : 2);
    const [delay, setDelay] = useState((_j = (_h = (_g = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.animations) === null || _g === void 0 ? void 0 : _g.apparition) === null || _h === void 0 ? void 0 : _h.delay) !== null && _j !== void 0 ? _j : 0);
    const handleModalClose = () => {
        setAnimationsModalOpened(false);
    };
    const handleSaveClick = () => {
        if (!layoutItem)
            return;
        layoutService.updateLayoutItem({
            ...layoutItem,
            animations: {
                apparition: {
                    delay,
                    duration,
                    type: value.toString(),
                },
            },
        });
        handleModalClose();
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        setDelay((_b = (_a = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.animations) === null || _a === void 0 ? void 0 : _a.apparition.delay) !== null && _b !== void 0 ? _b : 0);
        setDuration((_d = (_c = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.animations) === null || _c === void 0 ? void 0 : _c.apparition.duration) !== null && _d !== void 0 ? _d : 2);
        setValue((_f = (_e = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.animations) === null || _e === void 0 ? void 0 : _e.apparition.type) !== null && _f !== void 0 ? _f : "none");
    }, [layoutItem, setValue]);
    return (React.createElement(Modal, { isOpen: animationsModalOpened, onClose: handleModalClose, scrollBehavior: "inside", size: "2xl" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, { "data-testid": "animation-modal-test-id" },
            React.createElement(ModalHeader, null, "Animations"),
            React.createElement(ModalCloseButton, null),
            React.createElement(ModalBody, { display: "flex", flexDirection: "column", gap: 2 },
                React.createElement(Box, null,
                    React.createElement(Text, { fontWeight: "bold" }, "Apparition"),
                    React.createElement(Text, { color: "gray.500" }, "Lancer une animation lorsque le widget appara\u00EEt")),
                React.createElement(AnimationsRadioGroup, { getRadioProps: getRadioProps, getRootProps: getRootProps, duration: duration }),
                React.createElement(Grid, { gridTemplateColumns: "repeat(3, 1fr)", gridGap: 4 },
                    React.createElement(GridItem, null,
                        React.createElement(FormControl, null,
                            React.createElement(FormLabel, { ...FormLabelStyle }, "Dur\u00E9e"),
                            React.createElement(InputGroup, { size: "sm" },
                                React.createElement(NumberInput, { min: 1, defaultValue: duration, onChange: (value) => {
                                        if (value === "")
                                            return;
                                        setDuration(parseInt(value));
                                    } }),
                                React.createElement(InputRightAddon, { children: "s" })))),
                    React.createElement(GridItem, null,
                        React.createElement(FormControl, null,
                            React.createElement(FormLabel, { ...FormLabelStyle }, "D\u00E9lai"),
                            React.createElement(InputGroup, { size: "sm" },
                                React.createElement(NumberInput, { defaultValue: delay, onChange: (value) => {
                                        if (value === "")
                                            return;
                                        setDelay(parseInt(value));
                                    } }),
                                React.createElement(InputRightAddon, { children: "s" })))))),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { variant: "ghost", mr: 3, onClick: handleModalClose }, "Fermer"),
                React.createElement(Button, { colorScheme: "orange", onClick: handleSaveClick }, "Sauvegarder")))));
};
